 const serviceTitle = {
    titleKey: 'services.title',
    subTitleKey: 'services.subTitle',
    moreInfoKey: 'services.moreInfo',
}

export default serviceTitle;